"use client"

import React from "react"

import { transformQuotesToItems } from "@/helpers/utils"
import { QuoteType } from "@/types/quote"
import { QuoteCarouselDynamic } from "@/ui/components/dynamic"

import PageGrid from "../../PageGrid"

interface ImpactQuoteProps {
  quoteData: QuoteType[]
}
const ImpactQuoteSection: React.FC<ImpactQuoteProps> = ({ quoteData }) => (
  <section className="bg-blue-2.5">
    <PageGrid
      className="pt-10 pb-4 md:pt-9 md:pb-14 lg:py-16 xl:pb-22 xl:pt-28 text-gray-85"
      isGrid={false}
    >
      <div className="w-full overflow-x-hidden">
        <QuoteCarouselDynamic
          quoteItems={transformQuotesToItems(quoteData)}
          useGridLayout
          showQuotee
          showDots
        />
      </div>
    </PageGrid>
  </section>
)

export default ImpactQuoteSection
